export enum EditSignatureTypes {
  Default = 'default',
  Draw = 'draw',
  Upload = 'upload',
}
